import BaseCardBehavior from './BaseCardBehavior';
import CardStateHelper from '../CardStateHelper';
import { CardTask } from '../CardTasks';
import { CardType } from '../../../Prototype/Level/Card/CardType';
import { CardModifierType } from '../../../Prototype/Level/Card/CardModifierType';
import {
    SCORE_SCYTHE_CARD,
    SCORE_SCYTHE_TARGET_CARD,
} from '../../../Constants/Score';
import { IGameState } from '../../Game/IGameState';
import { ICardsState } from '../ICardState';
import { initialCardStateData } from '../initialCardStateData';
import CardStateModifierHelper from '../CardStateModifierHelper';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class ZapCardBehavior extends BaseCardBehavior {
    public play(state: IGameState): IGameState {
        let cardsState: ICardsState = state.levelState.cardsState;
        const currentCardState = CardStateHelper.getCardState(
            cardsState,
            this.cardID
        );

        const targets: string[] = [];

        if (currentCardState === CardState.IN_PLAY) {
            const zapCardData = cardsState.cards[this.cardID];
            const offsetZap = zapCardData.offset ?? initialCardStateData.offset.clone();

            // Find all removable cards in play.
            // Regular, rising/lowering, fog, ice, bomb or pickaxe (value).
            const removableCardIDs = cardsState.inPlay.filter(
                cardID => cardsState.cards[cardID].type === CardType.value
            );

            removableCardIDs.forEach((cardID: string) => {
                const cardData = cardsState.cards[cardID];
                const offsetCard = cardData.offset ?? initialCardStateData.offset.clone();

                if (cardData.type === CardType.gold) return;

                if (
                    Math.abs(zapCardData.x + offsetZap.x - cardData.x + offsetCard.x) < 2000 &&
                    Math.abs(zapCardData.y + offsetZap.y - cardData.y + offsetCard.y) < 100
                ) {
                    if (
                        !CardStateHelper.getCardBehavior(
                            cardsState,
                            cardID
                        ).isBlocked(cardsState, [CardModifierType.fog])
                    ) {
                        cardsState = CardStateHelper.setCardDiscarded(
                            cardsState,
                            cardID
                        );

                        // Collect affected card IDs for task data.
                        targets.push(cardID);

                        const modifier = cardsState.cards[cardID].modifiers.find(m => m.type === CardModifierType.connected);
                        if (modifier) {
                            CardStateHelper.setCardDiscarded(cardsState, modifier.properties.cardID);
                            targets.push(modifier.properties.cardID);
                        }
                    }
                }
            });
        }

        // Discard self.
        cardsState = CardStateHelper.setCardDiscarded(cardsState, this.cardID);

        // Add score.
        const scores: number[] = [
            SCORE_SCYTHE_CARD,
            ...Array(targets.length).fill(SCORE_SCYTHE_TARGET_CARD),
        ];
        cardsState = CardStateHelper.addTurnScore(cardsState, ...scores);

        // Trigger zap animation task.
        cardsState = CardStateHelper.setStateTaskData(cardsState, {
            task: CardTask.ZAP,
            cards: [this.cardID, ...targets],
            cardsScore: [...scores],
        });

        targets.forEach((cardID) => {
            cardsState = CardStateModifierHelper.onCardDiscarded(
                cardsState,
                cardID
            );
        });

        // Update all cards behavior after some of them are discarded.
        cardsState = CardStateHelper.updateCards(cardsState);

        // Clear undo history when a zap card is played.
        cardsState = CardStateHelper.clearUndoHistory(cardsState);

        return {
            ...state,
            levelState: {
                ...state.levelState,
                cardsState,
            },
        };
    }
}
